import { useCallback, useState } from 'react';
import { useHistory } from 'react-router-dom';
import ReactModal from 'react-modal';
import MailchimpSubscribe from 'react-mailchimp-subscribe';

import useQueryParams from 'hooks/useQueryParams';

import AppLogo from 'shared_components/AppLogo';
import Button from 'shared_components/Button';
import InputText from 'shared_components/InputText';
import Text from 'shared_components/Text';
import { CloseIcon } from 'shared_components/SVGIcons';

import styles from './styles.module.scss';
import ErrorAlert from 'shared_components/ErrorAlert';

const URL =
  'https://kolectiv.us1.list-manage.com/subscribe/post?u=f3fdc919794a088c6a3b6ab7b&id=f35abafd66';

const SubscribeModal = () => {
  const history = useHistory();
  const { modal } = useQueryParams();

  const isOpen = modal === 'subscribe';

  const [email, setEmail] = useState('');

  const handleDismiss = useCallback(() => {
    history.push({
      pathname: history.location.pathname,
      hash: history.location.hash,
    });
  }, [history]);

  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={handleDismiss}
      closeTimeoutMS={300}
      className={{
        base: styles.subscribeModal,
        afterOpen: styles.afterOpen,
        beforeClose: styles.beforeClose,
      }}
      overlayClassName={{
        base: styles.subscribeModalOverlay,
        afterOpen: styles.overlayAfterOpen,
        beforeClose: styles.overlayBeforeClose,
      }}
    >
      <CloseIcon
        size={60}
        role="button"
        onClick={handleDismiss}
        className={styles.closeIcon}
      />
      <MailchimpSubscribe
        url={URL}
        render={({
          subscribe,
          status,
          message,
        }: {
          subscribe: (data: { EMAIL: string }) => void;
          status: 'sending' | 'error' | 'success';
          message: string | null;
        }) => (
          <form
            onSubmit={(e) => {
              e.preventDefault();
              subscribe({ EMAIL: email });
            }}
            className={styles.content}
          >
            <AppLogo className={styles.appLogo} />

            {/* <Text
              centered
              uppercase
              size="xl"
              type="white"
              weight="extralight"
              className={styles.heading}
            >
              <Text weight="bold" className={styles.heading}>
                Get informed
              </Text>{' '}
            </Text> */}

            <ErrorAlert
              message={
                message?.includes('already subscribed')
                  ? 'You’re already subscribed to Kolektiv.'
                  : message || undefined
              }
            />

            <label className={styles.formItem}>
              <Text
                block
                centered
                uppercase
                size="sm"
                weight="semibold"
                className={styles.formLabel}
              >
                Email Address
              </Text>
              <InputText
                required
                type="email"
                value={email}
                onChange={setEmail}
                className={styles.formInput}
              />
            </label>

            <Button
              htmlType="submit"
              loading={status === 'sending'}
              className={styles.button}
            >
              SUBMIT
            </Button>
          </form>
        )}
      />
    </ReactModal>
  );
};

export default SubscribeModal;
